import mapIconSvg from '@/../img/map.svg';
import { NAV_ITEMS } from '@/constants';
import { iconifyThisSvg } from '@/utils/svg-iconifier';
import { useLocation } from 'react-router-dom';
import { NavItem } from '../../nav-item';
import { useVerticalBarNavigation } from '../use-vertical-bar-navigation';

const mapIcon = iconifyThisSvg(mapIconSvg, { height: 24, width: 24 });

export const MapNavItem = () => {
  const { goToTab } = useVerticalBarNavigation();
  const { pathname } = useLocation();

  return (
    <NavItem
      id="map"
      icon={mapIcon}
      tooltip="Map"
      ariaLabel="Go to Map View"
      isActive={pathname.includes(NAV_ITEMS.home)}
      onClick={() => {
        goToTab(NAV_ITEMS.home);
      }}
    />
  );
};
